const tooltipTriggers = document.querySelectorAll('.tooltip-pack__trigger');
const tooltipContainers = document.querySelectorAll('.tooltip-pack');
const tooltipClose = document.querySelectorAll('.tooltip-pack');

function isTouchDevice() {
  return (('ontouchstart' in window) ||
     (navigator.maxTouchPoints > 0) ||
     (navigator.msMaxTouchPoints > 0));
}

if (isTouchDevice()) {
  tooltipTriggers.forEach(el => {
    el.onclick = (e) => {
      e.preventDefault();
      e.stopPropagation();
      el.parentElement.classList.toggle('active');
    }
  });
  tooltipClose.forEach(el => {
    el.onclick = (e) => {
      e.stopPropagation();
      el.closest('.tooltip-pack').classList.remove('active');
    }
  });
  document.addEventListener('click', event => {
    tooltipContainers.forEach(el => {
      el.classList.remove('active');
    });
  });
}


